

import React from "react";
import RightSidebarGlobal from "../../Components/RightSidebarGlobal";
import chart_market from "../../Assets/images/chart_market.jpg";


function MarketingProcurement (){

    return (
        <>
    <div class="wrapper">
    <div class="inner_page_Sec">
    <div class="col-sm-8 float-left left_sec searchPageTop">

    <h1>Marketing Procurement</h1>

    {/* <p>The marketing division   of BENFED is mainly engaged in procurement of paddy from different   farmers of the state of West Bengal through various societies enlisted   with BENFED. This mechanism is performed under MSP (Minimum Support   Price) of the Government of India. MSP is a form of market intervention   by the Government of India to insure agricultural producers against any   sharp fall in farm prices. The MSP are announced at the beginning of the   sowing season of certain crops in the basis of the recommendations of   the Commission of Agricultural Costs and Prices (CACP). It thus helps   the producers/farmers against excessive fall in price during high   production years, the major objective being to support the farmers from   distress sales. The department is also engaged in procurement of other   agricultural produce like pulses, vegetables(mainly potato), grains,   spices etc. by ensuring support price to the respective farmers and also   by selling at market price in the open market or by supplying them to   the Government agencies. Under KMS (2015-16) more than 2 lakh farmers   are benefited through the help of BENFED. The primary focus of the   marketing team is to provide remunerative price to the farmers and   supply to the consumers at moderate rate.</p>
  <h2>Paddy Procurement Process  </h2>
  
    <ul>
      <li>Application from interested Societies duly recommended by Cooperative Inspector is to be submitted.</li>
      <li>DCFS/ARCS approval and tagging with the rice mill will be done in   the District Level Monitoring Committee Meeting (now held almost daily )</li>
      <li>Tripartite agreement between BENFED, Cooperative society and Rice Mill are done.</li>
      <li>Work order issued by BENFED to the society, specifying the amount   to be procured and tagged rice mill where paddy to be delivered.</li>
      <li>Society purchases and enters it into Muster Roll along with the   designated software designed and implemented by Food &amp; Supplies   Department.</li>
      <li>Paddy is sent to Rice Mill in Society's challan with a copy to the BENFED.</li>
      <li>Block Extension Officer certifies proof of receipt of paddy at the Rice Mill. Entered into the Register of Rice Mill.</li>
    </ul> */}

    <p>
The Marketing Department is headed by the Manager (Marketing) under the supervision of General Manager (Business). Other officers in this Department assigned to specific responsibilities are in the ranks of Deputy Manager, Assistant Manager, Deputy Manager (Accounts), Marketing Executive (contractual employment). Other staff include the Assistant, Accounts Assistant (contractual employment), and Sub-staff.
</p>

<p>Marketing Department responsible and undertakes procurement of different agricultural produces from farmers through co-operative 
  societies that includes grains (Chiefly paddy), vegetables (Mainly potato), pulses (Urad, lentil etc.), oilseeds (Sesame, Mustard, Sunflower etc.), 
  Jute both at Minimum Support Price (MSP) & Market price depending on schemes. Procured commodity then supplied to the Government 
  Agencies/Department i.e. <a href="https://food.wb.gov.in/" target="_blank">Department of Food & Supplies, Government of West Bengal</a> (DFS), 
  <a href="https://fci.gov.in/" target="_blank">Food Corporation of India (FCI)</a>, 
  <a href="http://www.jutecorp.in/" target="_blank">Jute Corporation of India (JCI)</a>,  
  <a href="https://www.nafed-india.com/" target="_blank">National Cooperative Marketing Federation of India Ltd. (NAFED)</a>   
  as per instruction and terms laid. BENFED is playing its small yet important role in the flagship Government initiatives of 
  Food Security and Price Stabilization of Agricultural commodities. </p>



<p>The performance of BENFED in Decentralized Paddy Procurement Operation under the supervision 
  of Department of Food & Supplies, Government of West Bengal in recent past is given here:-</p>
<div className="table_data">
  <table border="0" cellspacing="0" cellpadding="0">
  <thead>
    <tr>
      <th>Sl No.</th>
      <th>Name of KMS</th>
      <th>Districts covered</th>
      <th>Total No of Co operative Society involved</th>
      <th>No of Rice Mill attached</th>
      <th>Paddy Procured (in Lakh MT)</th>
      <th>Minimum Support Price (MSP)/MT in Rs.</th>
      <th>Value of Paddy Procured (Rs.)</th>
      <th>Resultant Rice (in Lakh MT)</th>
      <th>No of Farmers benefitted</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>2021-22</td>
      <td>20</td>
      <td>535</td>
      <td>341</td>
      <td>5.08</td>
      <td>19400</td>
      <td>985.58</td>
      <td>3.45</td>
      <td>257639</td>
    </tr>
    <tr>
      <td>2</td>
      <td>2022-23</td>
      <td>20</td>
      <td>460</td>
      <td>314</td>
      <td>4.50</td>
      <td>20400</td>
      <td>918.38</td>
      <td>3.06</td>
      <td>213708</td>
    </tr>
    <tr>
      <td>3</td>
      <td>2023-24</td>
      <td>20</td>
      <td>539</td>
      <td>316</td>
      <td>4.54</td>
      <td>21830</td>
      <td>993.01</td>
      <td>3.09</td>
      <td>141857</td>
    </tr>
    <tr>
      <td>4</td>
      <td>2024-25</td>
      <td>20</td>
      <td>512</td>
      <td>351</td>
      <td>5.24</td>
      <td>23000</td>
      <td>1205.67</td>
      <td>3.56</td>
      <td>159616</td>
    </tr>
  </tbody>
</table>
</div>

<h2>FLOWCHART PROVIDING A OVERALL GLIMPSE OF PADDY PROCUREMENT:-</h2>

<p><img src={`${chart_market}`} alt=""/></p>

<h2>Oilseeds & Pulses Procurement</h2>
<p >Besides Food Grain production and availability of various Oil Seed and Pulses are crucial elements of food security in 
  India. These commodities are price sensitive in nature being consumed significantly in India. As per as BENFED concerned, 
  the following procurement initiatives were undertaken in conjunction with NAFED who had been the Central level agency 
  for procurement of these Ravi Crops.</p>

<div className="table_data">
  <table border="0" cellpadding="0" cellspacing="0">
  <thead>
    <tr>
      <th>Sl. No.</th>
      <th>Marketing Season</th>
      <th>Districts Covered</th>
      <th>No of Co-operative Society Involved</th>
      <th>Name of Oilseed/Pulses</th>
      <th>Procurement Qty. (in Qtl.)</th>
      <th>Minimum Support Price (MSP)/Qtl in Rs.</th>
      <th>Overall Value of Procurement (Rs. crore)</th>
      <th>No. of Farmers Benefitted</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>2017-18</td>
      <td>4</td>
      <td>24</td>
      <td>SESAME</td>
      <td>37398.00</td>
      <td>5000</td>
      <td>18.70</td>
      <td>2842</td>
    </tr>
    <tr>
      <td>2</td>
      <td>2018-19</td>
      <td>4</td>
      <td>37</td>
      <td>URAD DAL</td>
      <td>67893.00</td>
      <td>5400</td>
      <td>36.66</td>
      <td>9029</td>
    </tr>
    <tr>
      <td>3</td>
      <td>2018-19</td>
      <td>1</td>
      <td>13</td>
      <td>MUSTARD</td>
      <td>8266.00</td>
      <td>4000</td>
      <td>3.31</td>
      <td>2170</td>
    </tr>
  </tbody>
</table>
</div>


    </div>
    <div class="col-sm-4 float-left">
    <RightSidebarGlobal/>
    </div>

    </div>
    </div>

    </>
    )
}

export default MarketingProcurement